import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: [
    '../../app.component.css',
    './confirm.component.css']
})
export class ConfirmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
